"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./CardComparisonRow.css");
require("./CardComparisonRow.mobile.css");
require("./CardComparisonRow.tablet.css");
require("./CardComparisonRow.desktop.css");
var icons = require("../../../../../styles/att-icons.css");
var CardComparisonRow = /** @class */ (function (_super) {
    __extends(CardComparisonRow, _super);
    function CardComparisonRow(props) {
        var _this = _super.call(this, props) || this;
        _this.childrenArray = React.Children.toArray(_this.props.children);
        return _this;
    }
    CardComparisonRow.prototype.render = function () {
        var current = this.props.data.current;
        var comparisonIndex = this.props.data.comparisonIndex;
        var cellClass = (this.props.data.showArrows) ?
            [styles.cell, styles.left, styles.cellWithArrows].join(' ') : [styles.cell, styles.left].join(' ');
        return (React.createElement("div", { "data-test-id": this.props.testId, className: styles.row },
            React.createElement("div", { className: cellClass },
                this.showArrows(false),
                this.childrenArray[comparisonIndex],
                this.showArrows(true)),
            React.createElement("div", { className: [styles.cell, styles.right].join(' ') }, this.childrenArray[current])));
    };
    CardComparisonRow.prototype.showArrows = function (isLeft) {
        if (this.props.data.showArrows) {
            var callBack = isLeft ? this.props.events.goLeft : this.props.events.goRight;
            var arrowIcon = !isLeft ? styles.left : '';
            var arrowClass = [icons.attIcon, icons.attIconCarouselArrow, styles.arrowsButton, arrowIcon].join(' ');
            var disabled = callBack === null;
            return (React.createElement("div", { className: styles.arrowContainer },
                React.createElement("button", { className: arrowClass, onClick: callBack, disabled: disabled })));
        }
    };
    return CardComparisonRow;
}(React.Component));
exports.default = CardComparisonRow;
//# sourceMappingURL=CardComparisonRow.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/CardComparisonRow/CardComparisonRow.js
// module id = 1309
// module chunks = 8